module.exports = __webpack_public_path__ + "img/logo_nase_ptice.08da3616.jpg";